export const DURATION = '200ms,  0.2s';
export const DURATION_500 = '500ms,  0.5s';
export const DURATION_700 = '700ms,  0.7s';
export const DURATION_1000 = '1000ms, 1s';
